/* eslint-disable */
/**
 * Cookie consent bar
 *
 * Listen for acceptance via document.addEventListener('cookies-accepted')
 */
 export default {
  init() {
    this.setDeclineFunction();
    this.addCookieEventListeners();
    this.$element = document.querySelector('.js-cookie-consent');
    if (!this.$element) return;

    const cookieValue = this.getCookieValue();
    if (cookieValue === '') {
      this.renderCookie();
      return;
    }
    if (cookieValue === '1') {
      this.dispatchCookieConsent();
    }
  },

  dispatchCookieConsent() {
    const event = new CustomEvent("cookies-accepted");
    document.dispatchEvent(event);
  },

  /**
   * Attach a global decline function to the window
   * Can be called in shortcodes
   */
  setDeclineFunction() {
    window.SchoutenDeclineCookies = () => {
      this.setDeclineCookie();
    };
  },

  /**
   * get cookie getcookie
   *
   * @returns {string}
   */
  getCookieValue() {
    return document.cookie.replace(/(?:(?:^|.*;\s*)cookieV2Accepted\s*=\s*([^;]*).*$)|^.*$/, '$1');
  },

  /**
   * set cookie value
   */
  setAcceptCookie() {
    document.cookie = 'cookieV2Accepted=1;max-age=31536000;secure;samesite=strict;path=/'; // one year
  },

  setDeclineCookie() {
    document.cookie = 'cookieV2Accepted=0;max-age=86400;secure;samesite=strict;path=/'; // one month
  },

  /**
   * renderCookiebar
   */
  renderCookie() {
    this.$element.classList.remove('u-hide');
    this.$element.querySelector('.js-accept-cookie').addEventListener('click', () => {
      this.$element.outerHTML = '';
      this.setAcceptCookie();
      this.dispatchCookieConsent();
    });

    this.$element.querySelector('.js-decline-cookie').addEventListener('click', () => {
      this.$element.outerHTML = '';
      this.setDeclineCookie();
    });
  },

  addCookieEventListeners() {
    document.addEventListener('cookies-accepted', () => this.addFBTracker());
  },

  addFBTracker() {
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '1071282387616904');
    fbq('track', 'PageView');
  },
}
